(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("html3pdf", [], factory);
	else if(typeof exports === 'object')
		exports["html3pdf"] = factory();
	else
		root["html3pdf"] = factory();
})(self, function() {
return 